// API Configuration
export const API_URL = process.env.REACT_APP_API_URL;

// Stripe Payment Link
export const STRIPE_DONATE_LINK = process.env.REACT_APP_STRIPE_DONATE_LINK;

// Validate required environment variables
if (!API_URL) {
  console.error('Missing REACT_APP_API_URL environment variable. Check your .env file.');
}

if (!STRIPE_DONATE_LINK) {
  console.error('Missing REACT_APP_STRIPE_DONATE_LINK environment variable. Check your .env file.');
}
